module.exports = __webpack_public_path__ + "img/bg-topo.6a74a157.jpg";